import React, { memo } from "react";
import { IMaskInput } from "react-imask";

const Input = memo(({ id, value, setValue, mask, placeholder, type}) => {
  const handleChange = (value, mask) => setValue(value);

  return (
    
      <IMaskInput
        radix="."
        type="text"
        id={id}
        value={value}
        className="form__input"
        mask={mask}
		unmask={true}
        onAccept={handleChange}
		placeholder={placeholder}
      />

  );
});

export default Input;
